import styled from "styled-components";

export const RegisterCTA = styled.p`

    font-size: 0.75rem;
    font-weight: 400;

    color: var(--color-grey-1);
    text-align: center;

`